import React from "react";

function Footer() {
  return (
    <div>
      <div className="links">
        <div className="container">
          <div className="row">
            <div className="col-lg-2 col-md-6 mt-5">
              <a href="/#">About us</a>
              <a href="/#">About us</a>
              <a href="/#">About us</a>
              <a href="/#">About us</a>
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <a href="/#">International SEO Service</a>
              <a href="/#">International SEO Service</a>
              <a href="/#">International SEO Service</a>
              <a href="/#">International SEO Service</a>
            </div>
            <div className="col-lg-3 col-md-6 mt-5">
              <a href="/#">Hospitality & Travel SEO</a>
              <a href="/#">Hospitality & Travel SEO</a>
              <a href="/#">Hospitality & Travel SEO</a>
              <a href="/#">Hospitality & Travel SEO</a>
            </div>
            <div className="col-lg-4 col-md-6 mt-5">
              <a href="/#">Lorem ipsum dolor sit, amet consectetur</a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <p>© 2023 Delante® SEO Agency. All rights reserved.</p>
                </div>
                <div className="col-6 icon">
                  <i class="fa-brands fa-facebook"></i>
                  <i class="fa-brands fa-youtube"></i>
                  <i class="fa-brands fa-linkedin"></i>
                  <i class="fa-brands fa-square-instagram"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
